import React from 'react';
import './Meowing.css';
function Meowing() {
  return (
    <>
    <div className='uwu'>
      <h1 className='title'>Meowing</h1>
      <br></br>
      <img src="https://cdn.7tv.app/emote/60aecb385174a619dbc175be/3x.webp" alt="meow"></img>
      <img src="https://cdn.7tv.app/emote/632b50cec7950e03fc6ee844/3x.webp" alt=":3"></img>
      <img src="https://cdn.7tv.app/emote/623e3ac3db3ed5fb67b4393c/3x.webp" alt=":DD"></img>
      <img src="https://cdn.7tv.app/emote/63692198b8c178f75f1d446e/3x.webp" alt="catShy"></img>
      <img src="https://cdn.7tv.app/emote/60baa2643f56f4a8235d971c/3x.webp" alt="peepoShy"></img>
      <img src="https://cdn.7tv.app/emote/62b0e9fe6f979a871474a497/3x.webp" alt="wawa"></img>
      <br></br>
      <img src="https://cdn.7tv.app/emote/640e3418d7b4e2c3a0141245/4x.webp" alt="Meowa"></img>
      
    </div>
    </>
  )
}

export default Meowing